import PropTypes from 'prop-types';
import React from 'react';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import CriteriaDropdownComponent from '../../components/criteria/CriteriaDropdownComponent';
import CriteriaTextComponent from '../../components/criteria/CriteriaTextComponent';
import { t } from 'i18next';
import ActionLink from '../../components/ActionLink';
import BaseListContainer from '../../baseContainers/BaseListContainer';
import LeaveRequestService from '../../services/LeaveRequestService';
import LeaveRequestModel from '../../model/LeaveRequestModel';
import CriteriaCalendarRangeComponent from '../../components/criteria/CriteriaCalendarRangeComponent';
import YesNoDialog from '../../components/YesNoDialog';
import UserAbsenceReasonService from '../../services/UserAbsenceReasonService';
import { withRouter } from "react-router-dom";

class LeaveRequestListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new LeaveRequestService());
        this.state = {
            list: [],
            loading: true,
            size: 0,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            leaveRequestStatusOpt: [],
            leaveAbsenceReasonOptions: [],
            element: new LeaveRequestModel(),
        };
        this.absenceReasonsService = new UserAbsenceReasonService()
        this.handleOpenRemoveReportedDayDialog = this.handleOpenRemoveLeaveRequestDialog.bind(this);
    }

    updateSearchCriteria(criteria) {
        let baseUpdateSearchCriteria = {
            firstName: criteria.firstName,
            lastName: criteria.lastName,
            status: criteria.status,
            type: criteria.type,
            dateFrom: criteria.dateFrom,
            dateTo: criteria.dateTo,
            id: criteria.id,
            firstResult: criteria.firstResult,
            maxResult: criteria.maxResult,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };

        return baseUpdateSearchCriteria;
    }
    getCleanSearchCriteria() {
        let baseSearchCriteria = {
            firstName: '',
            lastName: '',
            status: {enumValue: "SUBMITTED", label: "Do akceptacji" },
            type: undefined,
            id: null,
            dateFrom: undefined,
            dateTo: undefined,
            firstResult: 0,
            maxResult: 10,
            sortField: 'id',
            sortAsc: true,
        };
        return baseSearchCriteria;
    }

    initializeFromBackend() {
        this.removeCookie("leaveRequestViewCalendar");
        super.initializeFromBackend();
        this.enumService
            .getEnumList('LeaveRequestStatus')
            .then((statusOptions) => {
                this.setState({ leaveRequestStatusOpt: statusOptions })
            }).catch((ex) => {
                this.showErrorMessage('Nie udało się pobrać listy statusów wniosków urlopowych');
            });
        super.initializeFromBackend();

        this.absenceReasonsService
            .getList({ firstResult: 0, maxResults: 1000, sortField: 'id', sortAsc: true, forLeave: true })
            .then((x) => {
                this.setState({
                    leaveAbsenceReasonOptions: x.content
                })
            }).catch((err) => {
                this.showErrorMessage('Nie udało się pobrać listy typow wnioskow urlopowych');
            })
    }

    renderCriteria() {
        const showPriceFilter = this.authService.isUserInAnyRole('ROLE_ADMIN', 'ROLE_CTO', 'ROLE_FINANCIAL_MANAGER'); 
        return (
            <div className='row'>             
                <CriteriaTextComponent
                    id='lastName-sc'
                    name='lastName'
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.lastName}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    label={t('leaveRequest.lastName')}
                    global={true}
                    refreshFromBackend
                    timeoutHandler={this.refreshTable}
                />
                <CriteriaTextComponent
                    id='firstName-sc'
                    name='firstName'
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.firstName}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    label={t('leaveRequest.firstName')}
                    global={true}
                    refreshFromBackend
                    timeoutHandler={this.refreshTable}
                />
                <CriteriaDropdownComponent
                    id='status-sc'
                    name='status'
                    showClear
                    label={t('leaveRequest.status')}
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.status}
                    options={this.state.leaveRequestStatusOpt}
                    placeholder='Wszystkie'
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    optionLabel='label'
                    filterOptionValue='label'
                    refreshFromBackend
                /> 
                   <CriteriaDropdownComponent
                    id='type-sc'
                    name='absenceReason'
                    showClear
                    label={t('leaveRequest.type')}
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.absenceReason}
                    options={this.state.leaveAbsenceReasonOptions}
                    placeholder='Wszystkie'
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    optionLabel='reason'
                    filterOptionValue='reason'
                    refreshFromBackend
                /> 
                     <CriteriaCalendarRangeComponent
                    id='date-sc'
                    idFrom='dateFrom-sc'
                    idTo='dateTo-sc'
                    label={t('leaveRequest.date')}
                    labelFrom={'od'}
                    labelTo={'do'}
                    name='date'
                    sharedLabel={false}
                    nameFrom='dateFrom'
                    nameTo='dateTo'
                    colClass='col-lg-8 col-sm-12'
                    from={this.state.criteria.dateFrom}
                    to={this.state.criteria.dateTo}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    refreshFromBackend
                    showButtonBar
                    maxDateInfinite
                    placeholderFrom={''}
                    placeholderTo={''}
                    inputsClassName='col-6'
                />
            </div>
        );
    }

    handleOpenRemoveLeaveRequestDialog(rowData, e) {
        if (e) {
            e.preventDefault();
        }
        this.setState({ deleteConfirmDialogVisible: true, elementToRemove: rowData, dialogViewMode: 'DELETE' });
    }


    actionTemplate(rowData) {
        const {detailUrl} = this.props;
        const href = `${detailUrl}/${rowData?.id}`;

        return (<div>
            <ActionLink
                iconName='mdi-eye'
                iconSide='left'
                iconSize='icon-large'
                handleClick={this.handleGoToDetail.bind(this, href)}
                variant='blue'
                className='edit-blue-link'
                key={'view-button'}
            />
              <ActionLink
            iconName='mdi-trash-can'
            iconSide='left'
            iconSize='icon-large'
                handleClick={this.handleOpenRemoveLeaveRequestDialog.bind(this, rowData)}
                variant='blue'
                className='edit-blue-link'
                key={'view-button'}
            />
        </div>
           
        );
    }
    prepareHeaderItems() {
        return this.authService.isUserInAnyRole('ROLE_LEAVE_REQUEST_MANAGE_EDIT') 
                    ? [
                  {
                      label: t('employee.addButton'),
                      type: 'BUTTON',
                      className: 'float-right',
                      variant: 'blue',
                      iconName: 'mdi-plus',
                      iconSide: 'left',
                      iconColor: 'white',
                      onClick: this.handleGoToNew,
                  },
              ]
            : [];
    }

    enumTemplate(field, rowData) {
        if (rowData[field] && rowData[field].label) {
            return rowData[field].label;
        } else if (rowData[field]) {
            return rowData[field];
        }
        return '';
    }

    prepareColumns() {
        const result = [        
            {field: 'lastName', header: t('employee.lastName'), sortable: false},
            {field: 'firstName', header: t('employee.firstName'), sortable: false}, 
            {field: 'dateFrom', header: "Początek", sortable: true},
            {field: 'dateTo', header: "Koniec", sortable: true},
            {field: 'absenceReason.reason', header: "Typ", sortable: true},
            {field: 'status', header: t('employee.status'), sortable: true, body: this.enumTemplate.bind(this, 'status')},
        ];
        result.push({
                key: 'actions',
                header: t('list.actions'),
                body: this.actionTemplate,
                className: 'table-column-action',
        });        
        return result;
    }

    handleDelete() {
        this.blockUi();
        this.service
            .remove(this.state.elementToRemove)
            .then((leaveRequest) => {
                this.unblockUi();
                this.persistMessage('success', '', t('leaveRequest.deleteSuccess'));
            })
            .catch((err) => {
                this.unblockUi();
                this.showErrorMessage(err.message, 10000);
            })
            .finally(() => {
                this.afterObjectUpdate();
                this.setState({deleteConfirmDialogVisible: false});
            });
    }

    afterObjectUpdate() {
        this.readMessage();
        this.refreshTable();
        this.unblockUi();
    }
    
    render() {
        return (
            <div className='container-fluid'>
                <BreadcrumbsItem to='/employee-leave-request-list'>{'Wnioski urlopowe'}</BreadcrumbsItem>
                {this.renderView()}
                {this.state.deleteConfirmDialogVisible ? (
                  
                  <YesNoDialog
                  visible={this.state.deleteConfirmDialogVisible}
                  header={t('leaveRequest.deleteHeader')}
                  name='visible'
                  onChange={(type, x, target) => {
                    
                      if (target.value) {
                      
                          this.handleDelete(target.value);
                      } else {
                          this.setState({deleteConfirmDialogVisible: false})
                      }
                  }}
                  onHide={() => this.setState({deleteConfirmDialogVisible: false})}
                   >
                      {t('leaveRequest.deleteConfirmation')}
                  </YesNoDialog> 
              ) : null}
            </div>
        );
    }
}

LeaveRequestListContainer.defaultProps = {
    detailUrl: '/#/employee-leave-request/details',
    newUrl: '/#/employee-leave-request/create',
    lazy: true,
};

LeaveRequestListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
};

export default withRouter(LeaveRequestListContainer);
